<!-- 普通商祥 -->
<!-- 历史组件命名与文件位置风格迥异规范混乱，标注好各个组件作用与文件位置，方便快速跳转 -->
<!-- 用到的mixin：src/mixin/mixProm.js src/mixin/mixTab.js -->
<!-- 用到的store：src/store/state/common.js src/store/state/product.js -->
<template>
  <section class="common-layout">
    <div class="container" ref="container">
      <!-- banner + 标题 + 价格 @/router/home/components/product/banner/product-banner -->
      <div ref="productId">
        <banner :product="product"></banner>
      </div>
      <!-- 过期退/随时退标签 @/router/home/components/product/label/newlabels -->
      <labels :product="product"></labels>
      <!-- 优惠券列表 ./components/product/promotion -->
      <promotions v-if="isShowPromotion"></promotions>
      <!-- 提示文字 @/router/home/components/product/tips/tip -->
      <tip></tip>
      <!-- 二级分销小程序 @/components/home/commission.vue -->
      <commission
        :spuId="spuId + ''"
        :commissionData="product.directCommission"
      />
      <!-- 选择sku @/router/home/components/product/chooseSku/chooseSku -->
      <chooseSku
        :showType="skuList.length > 1"
        :chooseSku="chooseSkuFn"
      ></chooseSku>
      <!-- 福袋商品图片 -->
      <img
        class="bless-img"
        v-if="blessingBag && blessImg"
        :src="blessImg"
        @click="toBless"
      />
      <!-- 选择门店 @/router/home/components/store -->
      <StoreInfo
        :product="product"
        :useRecovery="isRebuilding"
        @onStoreSelected="onStoreSelected"
      ></StoreInfo>
      <!-- 通用popup @/components/actionSheet/index -->
      <actionSheet :viewName="viewName"></actionSheet>

      <!-- spuType === 1 虚拟模版显示在此位置，非虚拟模版显示在下面 -->
      <BuyNotice
        :product="product"
        v-if="product.spuType === 1"
        ref="noticeId"
      />
      <!-- ./components/common/nav-tab -->
      <nav-tab
        ref="navTab"
        :scrollIndex.sync="scrollIndex"
        @change="changeTab"
        @scroll="handleScroll"
      />

      <!-- 联营月嫂默认服务详情图片 -->
      <div
        v-if="isPopYuesao && product.isContent"
        class="default-intro pf-medium mg-bottom"
      >
        服务详情
      </div>
      <!-- 其他商品图文详情 -->
      <template v-else>
        <!-- @/router/home/components/product/product-intro/index -->
        <productIntro :product="product" ref="introduceId" class="mg-bottom" />
      </template>
      <!-- 联营月嫂服务保障图 -->
      <div v-if="isPopYuesao" class="default-guarantee pf-medium mg-bottom">
        服务保障
      </div>
      <!-- 联营月嫂服务流程图 -->
      <div v-if="isPopYuesao" class="default-flow pf-medium mg-bottom">
        服务流程
      </div>
      <!-- 购买须知 ./components/product/product-intro/buy-notice -->
      <BuyNotice
        :product="product"
        v-if="product.spuType !== 1"
        ref="noticeId"
      />
      <!-- 用户评价 @/router/home/components/product/comment/commentEnter -->
      <div
        class="productComment"
        ref="commentId"
        v-show="commentData && commentData.total > 0"
      >
        <commentEnter
          :commentData="commentData"
          :id="spuId"
          :level4CategoryId="product.level4CategoryId"
          toAllComment="product"
        ></commentEnter>
      </div>
      <!-- 本店其他服务 @/router/home/components/product/other-product -->
      <otherServiceProduct
        ref="productId"
        v-if="otherServiceDatas.length > 0"
        :products="otherServiceDatas"
      />
      <!-- 锚点高度不足用 -->
      <div ref="bottom"></div>
      <!-- 底部购买按钮 @/router/home/components/product/actionBar/actionbar -->
      <actionbar class="action-bar">
        <template v-if="isBlessEligible || isBlessScorable">
          <btnTel
            slot="icons"
            v-show="product.businessPhone && isRebuilding"
            @tel="tel(product.businessPhone)"
          >
          </btnTel>
          <button
            class="btns btn-pink btn-detail"
            slot="buttons"
            @click="() => confirmBuy()"
          >
            {{ isBlessEligible ? '0元领取' : '立即购买' }}
          </button>
        </template>
        <template v-else-if="!showShareEarn">
          <btnTel
            slot="icons"
            v-show="product.businessPhone && isRebuilding"
            @tel="tel(product.businessPhone)"
          >
          </btnTel>
          <button v-if="preheatingInfo" slot="buttons" style="flex: 1">
            <div class="btn-preheating">
              <div class="promotion-buy">
                <p class="price">
                  秒杀价 &yen;{{ preheatingInfo.price / 100 }}
                </p>
                <p class="count-down">
                  <van-count-down
                    @finish="finish"
                    :time="preheatingInfo.countDownTime"
                    format="HH时mm分ss秒"
                  />
                  <span>后开始</span>
                </p>
              </div>
              <div class="normal-buy" @click="confirmBuy">立即购买</div>
            </div>
          </button>
          <button
            class="btns btn-pink btn-detail"
            slot="buttons"
            @click="confirmBuy"
            v-else-if="buyButtonEnable"
          >
            <div class="btn-title pf-simbold">
              {{ mixInfo.buyNowTitle }}
            </div>
            <div
              class="btn-subtitle"
              v-if="
                mixInfo.isReallyCheap &&
                !this.isSupportDeposit(this.selectedSku)
              "
            >
              <span>{{ mixInfo.buyNowSubtitle }}</span>
              <span>￥{{ mixInfo.minPrice }}</span>
              <span v-if="moreCmmdtySpecs">起</span>
            </div>
          </button>
          <button
            class="btns btn-grey btn-detail"
            slot="buttons"
            v-else-if="isSoldOut"
          >
            已售罄
          </button>
          <button class="btns btn-grey btn-detail" slot="buttons" v-else>
            暂不提供服务
          </button>
        </template>
        <template v-else-if="showShareEarn && product">
          <button
            v-if="showOpenCommision"
            class="btn-border btn-detail"
            slot="buttons"
            @click="
              () => {
                this.popStatus = true
              }
            "
          >
            查看佣金
          </button>
          <ShareButton
            slot="buttons"
            class="share-btn"
            :promotion-info="sharePromotion"
          >
            <button class="btn-share">立即分享</button>
          </ShareButton>
        </template>
      </actionbar>
      <!-- <submitBtn></submitBtn> -->
    </div>
    <!-- sku选择弹窗 @/router/home/components/product/chooseSku/product-type -->
    <popup v-model="popStatus" :skuList="skuList" :lazyRender="false">
      <product-type
        @handleClose="
          () => {
            this.popStatus = false
          }
        "
        @closeAction="closeAction"
      ></product-type>
    </popup>
    <van-popup v-model="isShowBuyQrcode" position="center">
      <div class="goBuyQrcode-dialog">
        <div class="goBuyQrcode-wrapper">
          <p>请打开孩子王APP或微信<br />扫一扫购买</p>
          <canvas id="goBuyQrcode" class="goBuyQrcode"></canvas>
        </div>
        <img
          @click="isShowBuyQrcode = false"
          class="btn-qrcode-close"
          src="@/assets/images/btn_qrcode_close@3x.png"
        />
      </div>
    </van-popup>

    <div class="menu_wkBox_back_box"></div>
  </section>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapState, mapMutations } from 'vuex'
import queryString from 'query-string'

import { setLiveCookie, setTitle } from '@/router/home/new/product.bus'
import { isEmptyObject, isNonEmptyArray, isRKHYAPP } from '@/utils'
import { showShareEarnInProductDetail } from '@/router/home/utils'
import { isHighLevelPregant } from '@/business/childbirth-service-package'
import navTab from './components/common/nav-tab'
import banner from '@/router/home/components/product/banner/product-banner'
import labels from '@/router/home/components/product/label/newlabels'
import chooseSku from '@/router/home/components/product/chooseSku/chooseSku'
import commission from '@/components/home/commission.vue'
import actionSheet from '@/components/actionSheet'
import tip from '@/router/home/components/product/tips/tip'
import StoreInfo from '@/router/home/components/store'
import productIntro from '@/router/home/components/product/product-intro/index'
import commentEnter from '@/router/home/components/product/comment/commentEnter'
import otherServiceProduct from '@/router/home/components/product/other-product'
import promotions from './components/product/promotion'
import submitBtn from '@/router/home/components/product/submitBtn/submit-btn'
import Popup from '@/components/action-sheet/popup'
import { Popup as VanPopup } from 'vant'
import productType from '@/router/home/components/product/chooseSku/product-type'
import actionbar from '@/router/home/components/product/actionBar/actionbar'
import btnTel from '@/components/common/btnTel'
import BuyNotice from './components/product/product-intro/buy-notice'
import B_COUPON from '@/business/coupon'
import ShareButton from '@/components/share/ShareButton.vue'
import { CountDown } from 'vant'
import qrcode from 'qrcode'
import { getDevice } from '@/utils'

import {
  setConfirmQuery,
  checkIfCustomisedGoods,
  goConfirm,
  getCZJConfirmUrl
} from '@/business/2-confirm'
// import m_store from './mixin/store'
import mixProm from '@/mixin/mixProm'
import mixTab from '@/mixin/mixTab'
import { E_PROMOTION_TYPE, ORDER_BELONG_BUSI_ENUM } from '@/config'
import log from '@/store/actions/log'
export default {
  //import引入的组件需要注入到对象中才能使用
  mixins: [mixProm, mixTab],
  // mixins: [m_store, mixProm],
  inject: {
    busiTelTrackParams: {
      default: null
    },
    buyTrackParams: {
      default: null
    },
    luckBagTrackParams: {
      default: null
    }
  },
  data() {
    return {
      btnTxt: '立即预约',
      empId: '',
      commentData: {},
      popStatus: false,
      storeInfo: null,
      isShowBuyQrcode: false
    }
  },
  //监听属性 类似于data概念
  computed: {
    ...mapState([
      'product',
      'isCzjSpu',
      'viewName',
      'comments',
      'commentCount',
      'selectedWorker',
      'selectedAddress',
      'selectedTime',
      'locationInfo',
      'selectedSku',
      'selectedPayMethod',
      'isMinProgram',
      'otherServiceDatas'
    ]),
    ...mapState('promotionInfo', {
      promotionInfo: state => state.promotionInfo
    }),
    ruleType() {
      return (
        (this.mixInfo &&
          this.mixInfo.seckillData &&
          this.mixInfo.seckillData.type) ||
        1
      )
    },
    ruleId() {
      return (
        (this.mixInfo &&
          this.mixInfo.seckillData &&
          this.mixInfo.seckillData.ruleId) ||
        ''
      )
    },

    isShowPromotion() {
      // 如果当前页面是秒杀，promList要去掉秒杀、立减活动
      let {
        couponList = [],
        promList = [],
        returnPurseList = [],
        returnServiceCoupons = []
      } = this.promotionInfo
      //过滤一下可用卷
      couponList = couponList.filter(x => B_COUPON.isUseable(x))
      let bool =
        isNonEmptyArray(couponList) || (promList && promList.length > 0)
      if (this.mixInfo.isSeckill) {
        let _promList = promList.filter(
          x =>
            +x.type !== E_PROMOTION_TYPE.FLASH_SALE &&
            +x.type !== E_PROMOTION_TYPE.DISCOUNT
        )
        bool = _promList.length > 0 || couponList.length > 0
      }
      return (
        bool || returnPurseList.length > 0 || returnServiceCoupons.length > 0
      )
    },
    sharePromotion() {
      if (this.mixInfo) {
        if (this.mixInfo.isSeckill) {
          return {
            price: this.mixInfo.minPrice * 100,
            tag: '秒杀'
          }
        } else {
          return {
            tag: this.mixInfo.tagName || this.mixInfo.tag
          }
        }
      }
      return {}
    },
    spuId() {
      return this.product.spuId
    },
    spuType() {
      return this.product.spuType
    },
    skuId() {
      const { selectedSku } = this
      if (selectedSku) return selectedSku.skuId
      return ''
    },
    skuList() {
      return this.product.cmmdtySpecs || []
    },
    skuInfo() {
      return `${this.product.skuid}|${this.product.category_id}|${this.product.brand_no}|${this.product.sellerid}|${this.product.is_self}|0`
    },
    // isCzjApp() {
    //     return this.$$isCZJApp()
    // },
    //购买按钮是否可用
    buyButtonEnable() {
      if (this.product.status === 4) {
        if (this.skuId) {
          if (this.selectedSku.availableInventory > 0) {
            return true
          } else {
            return false
          }
        }
        return true
      }
    },
    //是否是预热秒杀商品
    preheatingInfo() {
      return this.mixInfo && this.mixInfo.preheatingInfo
    },
    //是否卖完
    isSoldOut() {
      if (this.skuId) {
        if (this.selectedSku.availableInventory > 9992) {
          return false
        } else {
          return true
        }
      }
    },
    //是否显示优惠
    isShowDiscounts() {
      try {
        let results = []
        if (this.product.cmmdtyPromotions) {
          for (const p of this.product.cmmdtyPromotions) {
            results.push(...p.promotions)
          }
          results = results.filter(v => v.type === 3 || v.type === 4)
        }
        const hasCoupon =
          this.product.couponList && this.product.couponList.length > 0
        return hasCoupon || results.length > 0
      } catch (e) {
        console.log(e)
        return false
      }
    },
    isCustomisedGoods() {
      // 是否为定制商品
      const { source, saleAttribute } = this.product
      // return B_GOODS.isSKUGoods(source, saleAttribute)
      return checkIfCustomisedGoods(source, saleAttribute)
    },
    showShareEarn() {
      return showShareEarnInProductDetail()
    },
    showOpenCommision() {
      // 有分享赚信息并且多规格 展示查看佣金按钮
      return (
        this.product.shareSaleAmountVo &&
        this.product.shareSaleAmountVo.maxShareAmount &&
        this.skuList.length > 1
      )
    }
  },
  //监控data中的数据变化
  watch: {
    viewName(val, oldVal) {
      if (val !== oldVal && this.$store.state.needArrow) {
        this.$store.commit('setArrowState', false)
      }
    }
  },
  //方法集合
  methods: {
    ...mapMutations([
      'showActionSheet',
      'changeView',
      'setActionHeader',
      'setSelectedSku'
    ]),

    toBless() {
      this.luckBagTrackParams && this.$$newTrackClick(this.luckBagTrackParams)
      location.href =
        'https://life.cekid.com/v2/lucky-bag/home?naviType=4&kwtarget=blank'
    },
    //倒计时结束刷新页面
    finish() {
      setTimeout(() => {
        const newUrl = location.href
          .replace('&kwtarget=blank', '')
          .replace('kwtarget=blank&', '')
          .replace('kwtarget=blank', '')
        location.replace(newUrl)
      }, 1000)
    },

    closeAction(buyNow = false) {
      // 管弹窗，拉最新评论
      this.popStatus = false
      // this.getComments()
      this.confirmBuy(buyNow)
    },

    getComments() {
      if (this.isCzjSpu) {
        this.getCZJComments()
      } else {
        this.getYuerComments()
      }
    },
    async getYuerComments() {
      // 获取商品评价数据
      const commntJson = await this.$store.dispatch('getNewCommentList', {
        page: 1,
        size: 2,
        objectId: this.product.spuId,
        type: 9,
        uid: this.$$cookie('uid'),
        skey: this.$$cookie('skey'),
        property: 2 // 短评
      })
      if (+commntJson.code == 1) {
        this.commentData = commntJson.data || {}
      } else {
        this.$$toast({
          message: commntJson.msg
        })
      }
    },
    async getCZJComments() {
      // 获取商品评价数据
      const commntJson = await this.$store.dispatch('getCZJCommentList', {
        page: 1,
        size: 2,
        objectId: this.product.spuId,
        type: 4,
        uid: this.$$cookie('uid'),
        skey: this.$$cookie('skey')
      })
      if (commntJson && +commntJson.code == 1) {
        this.commentData = commntJson.data || {}
        if (this.commentData && this.commentData.count > 0) {
          this.commentData.total = this.commentData.count
        }
      } else {
        this.$$toast({
          message: commntJson.msg
        })
      }
    },
    async confirmBuy(buyNow = false) {
      const isInHzwScreen = getDevice() === 'hzw_screen'
      if (isInHzwScreen) {
        this.isShowBuyQrcode = true

        this.$nextTick(async () => {
          const url = location.href
          const dom = document.getElementById('goBuyQrcode')
          qrcode.toCanvas(dom, url, { errorCorrectionLevel: 'H' }, error => {
            if (error) {
              console.log(error)
              this.$$toast('生成二维码错误，请刷新后重试')
            }
          })
        })
        return
      }
      let _isHighLevelPregant = await isHighLevelPregant(this)
      if (!_isHighLevelPregant) return
      const skuid = this.skuId
      const popid = this.product && this.product.businessId

      if (skuid && (!this.isBlessScorable || buyNow)) {
        this.buynow()
      } else {
        this.chooseSkuFn('confirm')
      }
    },
    async buynow() {
      this.buyTrackParams && this.$$newTrackClick(this.buyTrackParams)
      const {
        spuType,
        skuId,
        ruleType,
        ruleId,
        empId,
        spuId,
        isCustomisedGoods,
        storeInfo,
        selectedPayMethod: payMethod
      } = this
      let {
        query: {
          hserecomkey = '',
          module = '',
          fromDailySale = '',
          liveid = '',
          livestore = '',
          mmz = ''
        }
      } = this.$route
      if (fromDailySale == '1') {
        module = '1'
      }
      const query = {
        ruleId,
        ruleType,
        empId,
        skuId,
        hserecomkey,
        module,
        mmz
      }
      if (liveid) {
        query.liveid = liveid
      }
      if (livestore) {
        query.livestore = livestore
      }

      if (payMethod == 'point') {
        query.payMethod = 'point'
      }

      let { spuId: newSpuId } = setConfirmQuery({
        spuId,
        storeInfo,
        query,
        isCustomisedGoods
      })

      const businessType = this.product && this.product.businessType
      if (
        this.isCzjSpu &&
        (+businessType === ORDER_BELONG_BUSI_ENUM.YCJ_ACTIVE ||
          +businessType === ORDER_BELONG_BUSI_ENUM.YCJ_PLAY)
      ) {
        //互动活动的商家类型走成长加确认页
        let url = getCZJConfirmUrl(query)
        location.href = url
      } else {
        goConfirm(newSpuId, query)
      }
    },
    // kefu() {
    //     this.$$kefu('XN0201', 'XN0101')
    // },

    chooseSkuFn(src) {
      if (src === 'confirm') {
        this.btnTxt = '确定'
      } else {
        this.btnTxt = '立即购买'
      }
      this.popStatus = true
      // this.changeView('specification')
      // this.setActionHeader({
      //   title: '',
      // })
      // this.showActionSheet()
    },
    tel(tel) {
      const skuid = this.skuId
      const popid = this.product && this.product.businessId
      this.busiTelTrackParams && this.$$newTrackClick(this.busiTelTrackParams)
      window.location.href = `tel:${tel}`
    },
    onStoreSelected(storeInfo) {
      // 定制SKU更换门店，默认也要带出子商品信息
      this.storeInfo = storeInfo
    },
    shareProduct() {
      // 立即分享
      this.$emit('share')
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  async created() {
    const vueQuery = this.$route.query || {}
    // this.skuId = vueQuery.skuId || ''
    // this.ruleType = vueQuery.ruleType || 1
    // this.ruleId = vueQuery.ruleId || ''
    this.empId = vueQuery.empid || ''
    this.getComments()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},

  components: {
    banner,
    labels,
    promotions,
    tip,
    StoreInfo,
    productIntro,
    commentEnter,
    otherServiceProduct,
    submitBtn,
    actionbar,
    chooseSku,
    actionSheet,
    commission,
    btnTel,
    Popup,
    productType,
    navTab,
    BuyNotice,
    ShareButton,
    [CountDown.name]: CountDown,
    VanPopup
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';

.introduce-server-layout {
  .serve_introduce {
    margin-top: 0;
  }
}
.store-info-layout {
  //   margin-top: rem(20px);
  padding-bottom: rem(20px);
}

.tabs-layout {
  height: rem(84px);
  margin-top: 0;
}
header {
  overflow: hidden;
  width: 100%;
  position: fixed;
  z-index: 99;
  left: 0;
  top: 0;
  height: rem(84px);
  background: #fff;

  .tabbar {
    display: flex;
    height: 100%;

    justify-content: center;

    .tabbar-item {
      color: #666666;
      display: flex;
      justify-content: center;
      font-size: rem(28px);
      text-align: center;
      flex: 1;

      align-items: center;
    }
    .active {
      box-sizing: content-box;
      color: #ff397e;
      font-weight: bold;
      font-size: rem(34px);
      position: relative;
      &:after {
        display: block;
        content: '';
        position: absolute;
        height: rem(6px);
        background: #ff397e;
        width: rem(24px);
        border-radius: 3px;
        bottom: rem(8px);
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}

.container {
  padding-top: 0;
}

.bless-img {
  width: rem(750px);
  height: rem(116px);
  margin-top: rem(20px);
}

.btn-detail {
  border-radius: rem(98px);
  margin: 0 rem(24px);
}

.btn-preheating {
  height: rem(80px);
  margin: 0 rem(30px);
  display: flex;
  .normal-buy {
    flex: 200;
    display: flex;
    opacity: 0.9;
    justify-content: center;
    align-items: center;
    border-radius: 0px rem(100px) rem(100px) 0px;
    background: linear-gradient(90deg, #fe7a03 0.7%, #f10025 100%),
      linear-gradient(270deg, #fea900 0%, #ffa602 100%);
    color: #ffffff;
    font-weight: 500;
    font-size: rem(28px);
  }
  .promotion-buy {
    flex: 326;
    display: flex;
    flex-direction: column;
    opacity: 0.9;
    justify-content: center;
    align-items: center;
    border-radius: rem(100px) 0px 0px rem(100px);
    background: linear-gradient(90deg, #030303 0.51%, #434542 100%),
      linear-gradient(90deg, #fe7a03 0.7%, #f10025 100%);
    /deep/ .van-count-down {
      color: white;
      font-size: rem(22px);
      line-height: 1;
      opacity: 0.54;
      transform: scale(0.95);
    }
    .price {
      color: #ffffff;
      font-weight: 500;
      margin-bottom: rem(4px);
      font-size: rem(26px);
      opacity: 0.54;
    }
    .count-down {
      display: flex;

      span {
        color: white;
        opacity: 0.54;
        transform: scale(0.95);
        font-size: rem(22px);
        line-height: 1;
      }
    }
  }
}

.default-intro {
  padding: rem(32px) rem(30px) 0;
  font-size: rem(32px);
  color: #121212;
  height: rem(2300px);
  background: url('~@/assets/images/product/new/default-intro1.png') 0 rem(66px) /
      100% rem(901px) no-repeat,
    url('~@/assets/images/product/new/default-intro2.png') 0 rem(967px) / 100%
      rem(1333px) no-repeat;
  background-color: white;
  margin-bottom: rem(20px);
}
.default-guarantee {
  padding: rem(32px) rem(30px) 0;
  font-size: rem(32px);
  color: #121212;
  height: rem(514px);
  background: url('~@/assets/images/product/new/default-guarantee.png') 0
    rem(66px) / 100% rem(448px) no-repeat;
  background-color: white;
  margin-top: rem(20px);
  margin-bottom: rem(20px);
}
.default-flow {
  padding: rem(32px) rem(30px) 0;
  font-size: rem(32px);
  color: #121212;
  height: rem(272px);
  background: url('~@/assets/images/product/new/default-flow.png') 0 rem(66px) /
    100% rem(206px) no-repeat;
  background-color: white;
  margin-bottom: rem(20px);
}

.productComment {
  padding: rem(24px) rem(24px) 0 rem(24px);
  margin-top: rem(20px);
  background: #fff;
}
.btn-title {
  font-size: rem(28px);
  line-height: 1;
}
.btn-subtitle {
  margin-top: rem(6px);
  line-height: 1;
  // margin-top: rem(-6px);
  font-size: rem(22px);
}
.share-btn {
  flex: 1;
}
/deep/.action-bar {
  border-top: rem(1.6px) solid #f0f0f0;
  .btn-border {
    width: rem(320px);
    height: rem(80px);
    line-height: rem(80px);
    color: #262626;
    overflow: hidden;
    background: transparent;
    border: rem(1px) solid #999999;
    border-radius: rem(40px);
  }
  .btn-share {
    height: rem(80px);
    line-height: rem(80px);
    margin-left: rem(24px);
    margin-right: rem(24px);
    width: calc(100% - 0.48rem);
    color: #fff;
    border-radius: rem(40px);
    background-image: linear-gradient(90deg, #ff8800 0%, #ff5900 100%);
  }
}

.mg-bottom {
  margin-bottom: rem(20px);
}
</style>
<style lang="scss">
@import '~@/assets/css/mixin';
.recovery-layout .productComment .commentEnter .commentEnterTitle {
  .userComment {
    font-size: 0.32rem;
    .number {
      margin-left: 0.08rem;
      font-size: 0.22rem;
      color: #262626;
      vertical-align: baseline;
      font-weight: 500;
    }
  }
}
</style>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.goBuyQrcode-dialog {
  text-align: center;
}
.goBuyQrcode-wrapper {
  background-color: transparent;
  background-image: url(https://hzwimspic-1251601690.image.myqcloud.com/hzwimspic/10001/03734180-2a1c-11ee-bfdc-2159bb754634_size_2292x2553);
  background-size: 100% 100%;
  width: rem(530.6px);
  height: rem(590px);
  text-align: center;
  padding-top: rem(35.2px);

  p {
    color: #000000;
    font-weight: 500;
    font-size: rem(32px);
    line-height: 1.3;
  }

  .goBuyQrcode {
    margin-top: rem(66px);
    width: rem(356px) !important;
    height: rem(354px) !important;
  }
}

::v-deep .van-popup {
  background-color: transparent;
}

.btn-qrcode-close {
  width: rem(60px);
  height: rem(60px);
  margin-top: rem(38.9px);
}
</style>
